import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Plus, Bell } from "lucide-react";
import { api } from "../../lib/api";
import { useLang } from "../../context/LanguageContext";
import StatusBadge from "../../components/StatusBadge";

export default function MyProjects() {
  const [projects, setProjects] = useState([]);
  const { t } = useLang();
  useEffect(() => { api.get("/projects/mine").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-6xl">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-cyan">{t("u_mp_kicker")}</div>
          <h1 className="mt-3 font-display text-3xl font-900 text-white">{t("u_mp_title")}</h1>
        </div>
        <Link to="/app/deposer" data-testid="myprojects-new" className="group inline-flex items-center gap-2 rounded-full bg-cyan px-6 py-3.5 text-sm font-600 text-void transition-all hover:-translate-y-0.5 hover:glow-cyan">
          <Plus size={17} /> {t("u_deposit_short")}
        </Link>
      </div>

      {projects.length === 0 ? (
        <div className="mt-10 border border-dashed border-white/15 p-16 text-center text-ink-secondary">{t("u_mp_empty")}</div>
      ) : (
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {projects.map((p) => (
            <Link key={p.id} to={p.status === "BROUILLON" ? `/app/deposer/${p.id}` : `/app/projets/${p.id}`} data-testid={`myproject-${p.id}`}
              className="group border border-white/10 bg-surface transition-all hover:-translate-y-1 hover:border-cyan/40">
              <div className="flex items-center justify-between border-b border-white/5 p-5">
                {p.logo ? <img src={p.logo} alt="" className="h-12 w-12 object-contain" /> : <div className="flex h-12 w-12 items-center justify-center bg-elevated font-display text-xl text-cyan">{(p.app_name || p.title || "?")[0]}</div>}
                <StatusBadge status={p.status} />
              </div>
              <div className="p-5">
                <div className="font-display text-lg font-600 text-white line-clamp-1">{p.app_name || p.title || t("u_untitled")}</div>
                <p className="mt-2 text-sm text-ink-secondary line-clamp-2">{p.description || "—"}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-ink-tertiary">
                  <span>{p.ref}</span>
                  <span>{p.submitted_at ? new Date(p.submitted_at).toLocaleDateString("fr-FR") : t("u_draft")}</span>
                </div>
                {p.unread_replies > 0 && (
                  <div className="mt-3 flex items-center gap-1.5 rounded-lg border border-cyan/40 bg-cyan/10 px-3 py-1.5 text-[11px] font-700 text-cyan" data-testid={`myproject-unread-${p.id}`}>
                    <Bell size={11} className="animate-pulse" /> {p.unread_replies} nouvelle{p.unread_replies > 1 ? "s" : ""} réponse{p.unread_replies > 1 ? "s" : ""} d'ACA
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
